import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTriangleRightMedium"><Path d="M9.5 6.5V17.5L16 12L9.5 6.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
